// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qlawKuMHvH8XOz7_T5Cm{border-radius:50%;place-content:center;width:24px;height:24px;display:grid}.qlawKuMHvH8XOz7_T5Cm.Xu6iUudG0Hkui3WsfyGS{width:16px;height:16px}.qlawKuMHvH8XOz7_T5Cm.WstbswEfJo3NyyF8EgDU{background:var(--background-brand-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `qlawKuMHvH8XOz7_T5Cm`,
	"small": `Xu6iUudG0Hkui3WsfyGS`,
	"bg": `WstbswEfJo3NyyF8EgDU`
};
export default ___CSS_LOADER_EXPORT___;
